export default __webpack_public_path__ + "static/media/logoSkywatch.44f46266.svg";